export const API_PREFIX = import.meta.env.DEV ? 'http://localhost:3001' : 'https://api.thewishbook.net'
export const CONTACT_EMAIL = 'webryck@gmail.com'
